const stack: string[] = []

/** Marca el origen de la escritura que está a punto de hacer set(). El guard lee el valor superior. */
export function pushGeometryOperation(name: string): () => void {
  stack.push(name)
  return () => {
    const index = stack.lastIndexOf(name)
    if (index >= 0) stack.splice(index, 1)
  }
}

export function currentGeometryOperation(): string {
  return stack[stack.length - 1] ?? 'state-write'
}
